import {
  GET_ALERT_DETAIL,
  GET_ALERT_DETAIL_SUCCESS,
  GET_ALERT_DETAIL_FAIL,
  CLOSE_ALERT,
  CLOSE_ALERT_FAIL,
  CLOSE_ALERT_SUCCESS,
  GET_MODEL_EXPLAINABILITY,
  GET_MODEL_EXPLAINABILITY_SUCCESS,
  GET_MODEL_EXPLAINABILITY_FAIL,
  GET_TRANSACTION,
  GET_TRANSACTION_SUCCESS,
  GET_TRANSACTION_FAIL,
  GET_HIST_ALERT_HEADER,
  GET_HIST_ALERT_HEADER_SUCCESS,
  GET_HIST_ALERT_HEADER_FAIL,
  GET_HIST_ALERT,
  GET_HIST_ALERT_SUCCESS,
  GET_HIST_ALERT_FAIL,
  GET_RISK_INDICATORS,
  GET_RISK_INDICATORS_SUCCESS,
  GET_RISK_INDICATORS_FAIL,
  GET_RISK_INDICATORS_GRAPH,
  GET_RISK_INDICATORS_GRAPH_SUCCESS,
  GET_RISK_INDICATORS_GRAPH_FAIL,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAIL,
  GET_FEATURE_CODES,
  GET_FEATURE_CODES_SUCCESS,
  GET_FEATURE_CODES_FAIL,
  GET_TRANSACTION_TYPES,
  GET_TRANSACTION_TYPES_SUCCESS,
  GET_TRANSACTION_TYPES_FAIL,
  GET_CUSTOMER_PROFILE,
  GET_CUSTOMER_PROFILE_SUCCESS,
  GET_CUSTOMER_PROFILE_FAIL,
  GET_CLUSTER_INFORMATION,
  GET_CLUSTER_INFORMATION_SUCCESS,
  GET_CLUSTER_INFORMATION_FAIL,
  RESET_INVESTIGATION_DETAIL_DATA,
  GET_LINKED_CUSTOMERS_C2C,
  GET_LINKED_CUSTOMERS_C2C_SUCCESS,
  GET_LINKED_CUSTOMERS_C2C_FAIL,
  GET_FEATURE_CATEGORY_SUCCESS,
  GET_FEATURE_CATEGORY_FAIL,
  GET_CLUSTER_VIEW_DESCRIPTION,
  GET_CLUSTER_VIEW_DESCRIPTION_SUCCESS,
  GET_CLUSTER_VIEW_DESCRIPTION_FAIL,
  UPDATE_ALERT_DETAIL
} from '../../actions/tm/investigationDetail';

const initialState = {
  alertDetail: {
    isFetching: false,
    fetched: false,
    data: null
  },
  closeAlert: {
    isPosting: false,
    error: null,
    data: null
  },
  clusterInformation: {
    isFetching: false,
    fetched: false,
    data: null
  },
  modelExplainability: {
    data: null,
    error: null
  },
  explainability: {
    data: null,
    error: null
  },
  transactionHeader: {
    data: null
  },
  transaction: {
    data: null,
    error: null
  },
  histAlertHeader: {
    data: null
  },
  histAlertResp: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },
  riskIndicatorsResp: {
    data: null,
    error: null
  },
  countriesResp: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },
  featureCodesResp: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },
  transactionTypesResp: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },
  featureCategoryResp: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },
  linkedCustomerC2CTypesResp: {
    isFetching: false,
    fetched: false,
    data: null,
    error: null
  },
  customerProfileResp: {
    isFetching: false,
    fetched: false,
    data: null
  },
  clusterViewDescription: {
    isFetching: false,
    fetched: false,
    data: null
  }
};

function investigationDetail(state = initialState, action) {
  switch (action.type) {
    case GET_ALERT_DETAIL:
      return {
        ...state,
        alertDetail: {
          isFetching: true,
          fetched: false,
          ...action.payload
        }
      };
    case GET_ALERT_DETAIL_SUCCESS:
    case UPDATE_ALERT_DETAIL:
      return {
        ...state,
        alertDetail: {
          isFetching: false,
          fetched: true,
          ...action.payload
        }
      };
    case GET_ALERT_DETAIL_FAIL:
      return {
        ...state,
        alertDetail: {
          isFetching: false,
          fetched: false,
          ...action.payload
        }
      };

    case CLOSE_ALERT:
      return {
        ...state,
        closeAlert: {
          isPosting: true,
          ...action.payload
        }
      };

    case CLOSE_ALERT_SUCCESS:
      return {
        ...state,
        alertDetail: {
          isFetching: false,
          fetched: true,
          ...action.payload
        },
        closeAlert: {
          isPosting: false,
          error: null
        }
      };

    case CLOSE_ALERT_FAIL:
      return {
        ...state,
        closeAlert: {
          isPosting: false,
          error: null
        }
      };

    //explainability
    case GET_MODEL_EXPLAINABILITY:
      return {
        ...state,
        isFetching: true,
        fetched: false
      };
    case GET_MODEL_EXPLAINABILITY_SUCCESS:
      return {
        ...state,
        modelExplainability: {
          data: action.payload,
          error: null
        }
      };
    case GET_MODEL_EXPLAINABILITY_FAIL:
      return {
        ...state,
        modelExplainability: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };
    case GET_TRANSACTION:
      return {
        ...state,
        transaction: {
          ...state.transaction,
          isFetching: true,
          fetched: false
        }
      };
    case GET_TRANSACTION_SUCCESS:
      if (action.payload.isScrolled) {
        const {
          transaction: {
            data: { alert_id, associated_transactions, customerId }
          }
        } = state;
        return {
          ...state,
          transaction: {
            isFetching: false,
            fetched: true,
            data: {
              alert_id,
              customerId,
              associated_transactions: associated_transactions.concat(
                action.payload.associated_transactions
              ),
              hasMore:
                Array.isArray(action.payload.associated_transactions) &&
                action.payload.associated_transactions.length >= 10
            },
            error: null
          }
        };
      }

      return {
        ...state,
        transaction: {
          isFetching: false,
          fetched: true,
          data: {
            ...action.payload,
            hasMore:
              Array.isArray(action.payload.associated_transactions) &&
              action.payload.associated_transactions.length >= 10
          },
          error: null
        }
      };
    case GET_TRANSACTION_FAIL:
      return {
        ...state,
        transaction: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };

    // Linked Customers C2C widget
    case GET_LINKED_CUSTOMERS_C2C:
      return {
        ...state,
        linkedCustomerC2CTypesResp: {
          ...state.linked_c2c_accounts,
          isFetching: true,
          fetched: false
        }
      };
    case GET_LINKED_CUSTOMERS_C2C_SUCCESS:
      if (action.payload.isScrolled) {
        const {
          transaction: {
            data: { alert_id, associated_transactions }
          }
        } = state;
        return {
          ...state,
          linkedCustomerC2CTypesResp: {
            isFetching: false,
            fetched: true,
            data: {
              alert_id,
              linked_c2c_accounts: associated_transactions.concat(
                action.payload.linked_c2c_accounts
              ),
              hasMore:
                Array.isArray(action.payload.linked_c2c_accounts) &&
                action.payload.linked_c2c_accounts.length >= 10
            },
            error: null
          }
        };
      }

      return {
        ...state,
        linkedCustomerC2CTypesResp: {
          isFetching: false,
          fetched: true,
          data: {
            ...action.payload,
            hasMore:
              Array.isArray(action.payload.linked_c2c_accounts) &&
              action.payload.linked_c2c_accounts.length >= 10
          },
          error: null
        }
      };
    case GET_LINKED_CUSTOMERS_C2C_FAIL:
      return {
        ...state,
        linkedCustomerC2CTypesResp: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };

    //hist alert
    case GET_HIST_ALERT_HEADER_SUCCESS:
      return {
        ...state,
        histAlertHeader: {
          data: action.payload
        }
      };
    case GET_HIST_ALERT_HEADER_FAIL:
      return {
        ...state
      };

    case GET_HIST_ALERT:
      return {
        ...state,
        histAlertResp: {
          ...state.histAlertResp,
          isFetching: true,
          fetched: false,
          ...action.payload
        }
      };
    case GET_HIST_ALERT_SUCCESS:
      if (action.payload.isScrolled) {
        const {
          histAlertResp: { alert_list }
        } = state;
        return {
          ...state,
          histAlertResp: {
            isFetching: false,
            fetched: true,
            alert_list: alert_list.concat(action.payload.alert_list),
            hasMore:
              Array.isArray(action.payload.alert_list) &&
              action.payload.alert_list.length >= 10
          }
        };
      }

      return {
        ...state,
        histAlertResp: {
          isFetching: false,
          fetched: true,
          hasMore:
            Array.isArray(action.payload.alert_list) &&
            action.payload.alert_list.length >= 10,
          ...action.payload
        }
      };
    case GET_HIST_ALERT_FAIL:
      return {
        ...state,
        histAlertResp: {
          isFetching: false,
          fetched: false,
          ...action.payload
        }
      };
    case GET_RISK_INDICATORS_SUCCESS:
      return {
        ...state,
        riskIndicatorsResp: {
          isFetching: false,
          fetched: true,
          ...action.payload
        }
      };
    case GET_RISK_INDICATORS_FAIL:
      return {
        ...state,
        riskIndicatorsResp: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };

    case GET_TRANSACTION_TYPES_SUCCESS:
      return {
        ...state,
        transactionTypesResp: {
          isFetching: false,
          fetched: true,
          error: null,
          ...action.payload
        }
      };

    case GET_TRANSACTION_TYPES_FAIL:
      return {
        ...state,
        transactionTypesResp: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };

    case GET_FEATURE_CATEGORY_SUCCESS:
      return {
        ...state,
        featureCategoryResp: {
          isFetching: false,
          fetched: true,
          error: null,
          ...action.payload
        }
      };

    case GET_FEATURE_CATEGORY_FAIL:
      return {
        ...state,
        featureCategoryResp: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };

    case GET_FEATURE_CODES_SUCCESS:
      return {
        ...state,
        featureCodesResp: {
          isFetching: false,
          fetched: true,
          error: null,
          ...action.payload
        }
      };
    case GET_FEATURE_CODES_FAIL:
      return {
        ...state,
        featureCodesResp: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };

    case GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countriesResp: {
          isFetching: false,
          fetched: true,
          error: null,
          ...action.payload
        }
      };
    case GET_COUNTRIES_FAIL:
      return {
        ...state,
        countriesResp: {
          isFetching: false,
          fetched: false,
          data: null,
          error: 'Error'
        }
      };

    case GET_RISK_INDICATORS_GRAPH_SUCCESS:
      const { customerProfileResp } = state;
      const newValue = {
        ...customerProfileResp,
        risk_indicators: [action.payload]
      };

      return {
        ...state,
        customerProfileResp: {
          ...customerProfileResp,
          risk_indicators: [action.payload]
        }
      };
    case GET_RISK_INDICATORS_FAIL:
      return {
        ...state
      };

    //get customer profile
    case GET_CUSTOMER_PROFILE:
      return {
        ...state,
        customerProfileResp: {
          isFetching: true,
          fetched: false,
          ...action.payload
        }
      };
    case GET_CUSTOMER_PROFILE_SUCCESS:
      return {
        ...state,
        customerProfileResp: {
          isFetching: false,
          fetched: true,
          ...action.payload
        }
      };
    case GET_CUSTOMER_PROFILE_FAIL:
      return {
        ...state,
        customerProfileResp: {
          isFetching: false,
          fetched: false,
          ...action.payload
        }
      };

    //get customer profile
    case GET_CLUSTER_INFORMATION:
      return {
        ...state,
        clusterInformation: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CLUSTER_INFORMATION_SUCCESS:
      return {
        ...state,
        clusterInformation: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CLUSTER_INFORMATION_FAIL:
      return {
        ...state,
        clusterInformation: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };

    //get clusterViewDescription
    case GET_CLUSTER_VIEW_DESCRIPTION:
      return {
        ...state,
        clusterViewDescription: {
          isFetching: true,
          fetched: false,
          data: action.payload
        }
      };
    case GET_CLUSTER_VIEW_DESCRIPTION_SUCCESS:
      return {
        ...state,
        clusterViewDescription: {
          isFetching: false,
          fetched: true,
          data: action.payload
        }
      };
    case GET_CLUSTER_VIEW_DESCRIPTION_FAIL:
      return {
        ...state,
        clusterViewDescription: {
          isFetching: false,
          fetched: false,
          data: action.payload
        }
      };

    case RESET_INVESTIGATION_DETAIL_DATA:
      return initialState;
    default:
      return state;
  }
}

export default investigationDetail;
